require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/footer/main-footer.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/footer/main-footer.legacy.js
// module id = 690
// module chunks = 31